module.exports = __webpack_public_path__ + "static/media/home-social-media-img1.69c1e0cc.svg";